<template>
  <VoiceMenuBar />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
